import { render, staticRenderFns } from "./purchaseCashbackCreate.vue?vue&type=template&id=4c1d0f1c&scoped=true&"
import script from "./purchaseCashbackCreate.vue?vue&type=script&lang=js&"
export * from "./purchaseCashbackCreate.vue?vue&type=script&lang=js&"
import style0 from "./purchaseCashbackCreate.vue?vue&type=style&index=0&id=4c1d0f1c&prod&lang=scss&scoped=true&"
import style1 from "./purchaseCashbackCreate.vue?vue&type=style&index=1&id=4c1d0f1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1d0f1c",
  null
  
)

export default component.exports